/* eslint-disable arrow-parens */
import adminApi from '@/api/admin';

// initial state
const state = {
  teachers: [],
  lastSignInDate: null,
  teachersOnPage: { count: 0, teachers: [] },
  teachersPaging: {
    filter: null,
    page: 1,
    pageSize: 20,
  },
};

// getters
const getters = {
  teachers: (currentState) => currentState.teachers,
  lastSignInDate: (currentState) => currentState.lastSignInDate,
  teachersPaging: (currentState) => currentState.teachersPaging,
  pagedTeachers: (currentState) => currentState.teachersOnPage,
};

// actions
const actions = {
  getTeachers({ dispatch, commit }, schoolCode) {
    dispatch('showLoader');
    adminApi.getTeachers(schoolCode).then((response) => {
      commit('setTeachers', { teachers: response.data });
      dispatch('hideLoader');
    });
  },
  getLastTeacherSignIn({ dispatch, commit }, schoolCode) {
    dispatch('showLoader');
    adminApi.getLastTeacherSignIn(schoolCode).then((response) => {
      commit('setLastSignInDate', { date: response.data });
      dispatch('hideLoader');
    });
  },
  getPagedTeachers({ dispatch, commit }, paging) {
    dispatch('showLoader');
    adminApi.getPagedTeachers(paging).then((response) => {
      commit('setPagedTeachers', { teachers: response.data, paging });
      dispatch('hideLoader');
    });
  },
  newTeacher({ dispatch }, teacher) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      adminApi.newTeacher(teacher).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  updateTeacher({ dispatch }, teacher) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      adminApi.updateTeacher(teacher).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  removeTeacher({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      adminApi.removeTeacher(id).then(
        (response) => {
          dispatch('getTeachers');
          dispatch('hideLoader');
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
};

// mutations
const mutations = {
  setTeachers(currentState, { teachers }) {
    currentState.teachers = teachers;
  },
  setLastSignInDate(currentState, { date }) {
    currentState.lastSignInDate = date;
  },
  setPagedTeachers(currentState, { teachers, paging }) {
    currentState.teachersOnPage = teachers;
    currentState.teachersPaging = paging;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/admin.js